const routes = {
  printerWizard: '/printers/wizard/',
  printerWizardSetup: '/printers/wizard/setup/',
}

export default routes
